import { render, staticRenderFns } from "./SendMsgPopup.vue?vue&type=template&id=fb8557f2&scoped=true&"
import script from "./SendMsgPopup.vue?vue&type=script&lang=js&"
export * from "./SendMsgPopup.vue?vue&type=script&lang=js&"
import style0 from "./SendMsgPopup.vue?vue&type=style&index=0&id=fb8557f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8557f2",
  null
  
)

export default component.exports